import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { MedicalCheckupResult, MedicalCheckupResultUtil } from '../../models/enums/medicalCheckupResult';

interface MedicalCheckupResultSelectProps {
    name: string;
    value: string | undefined;
    onChange: (event: SelectChangeEvent<string>) => void;
}

const MedicalCheckupResultSelect: React.FC<MedicalCheckupResultSelectProps> = ({ name, value, onChange }) => {
    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation();
        onChange({
            target: { name, value: '' },
        } as SelectChangeEvent<string>);
    };

    return (
        <FormControl variant="outlined" margin="dense" size="small" style={{ width: 200, marginRight: 10 }}>
            <InputLabel id="medical-checkup-result-label">Результат</InputLabel>
            <Select
                labelId="medical-checkup-result-label"
                id="medical-checkup-result-select"
                name={name}
                value={value || ''}
                label="Результат"
                onChange={onChange}
                sx={{
                    borderRadius: '10px',
                    ...(value
                        ? {
                            '& .MuiSelect-select': { paddingRight: '56px' },
                            '& .MuiSelect-icon': { right: 7 },
                        }
                        : {}),
                }}
                endAdornment={
                    value ? (
                        <IconButton
                            size="small"
                            aria-label="Очистить"
                            onClick={handleClear}
                            onMouseDown={(e) => e.preventDefault()}
                            sx={{
                                position: 'absolute',
                                right: 28,
                                top: '50%',
                                transform: 'translateY(-50%)',
                            }}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    ) : undefined
                }
            >
                {Object.values(MedicalCheckupResult).map((result) => (
                    <MenuItem key={result} value={result}>
                        {MedicalCheckupResultUtil.getStringValue(result)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MedicalCheckupResultSelect;
